import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { Plus } from "@phosphor-icons/react";
import { UserRolesPermissionsContext } from "../../../context/UserRolesPermissionsContext";
import { Modules } from "../../../application/common/enums/screen-name";
import { checkCreateEdit, checkManage, } from "../../../application/common/utils/roles-helper";
const OriginTopHeader = ({ openPopup, translate, }) => {
    const theme = useTheme();
    const { RolesPermissions } = useContext(UserRolesPermissionsContext);
    return (_jsxs(Box, { sx: {
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: { xs: 2, sm: 0 },
            padding: { xs: "16px 16px", sm: "16px 32px" },
            bgcolor: theme.palette.common.white,
            borderRadius: "24px",
        }, children: [_jsx(Typography, { variant: "h5", sx: {
                    color: theme.palette.text.primary,
                    fontSize: { xs: "1.25rem", sm: "1.5rem", md: "2rem" },
                    fontWeight: "bold",
                }, children: translate("Origins") }), (checkCreateEdit(RolesPermissions, Modules.RoleManagement) ||
                checkManage(RolesPermissions, Modules.RoleManagement)) && (_jsx(Button, { variant: "contained", startIcon: _jsx(Plus, { size: 20 }), onClick: openPopup, sx: {
                    bgcolor: theme.palette.primary.main,
                    color: theme.palette.common.white,
                    textTransform: "none",
                    borderRadius: "12px",
                    padding: "8px 24px",
                    "&:hover": {
                        bgcolor: theme.palette.primary.dark,
                    },
                }, children: translate("NewOrigin") }))] }));
};
export default OriginTopHeader;
